export const base = 'https://ey3aplwfs2.execute-api.us-east-1.amazonaws.com/Prod';
export const routes = {
    getCoin: `/v3/coin/`,
    postHacked: `/v3/hacked/`,
    getEvents: `/v3/events`,
    getEndingStakes: `/v3/stakes`,
    getVestings: `/v3/vesting`,
};
